import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Roadster",
    description: "Men White Printed Cotton Pure Cotton T-shirt",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/2475811/2018/4/20/11524206887970-Roadster-Men-Tshirts-9291524206887825-2.jpg",
    price: "599",
    discounted_price: "269",
    category_name: "Men",
    size: "L",
    availability: true,
    delivery_time: "6",
    rating: "4.2",
  },
  {
    _id: uuid(),
    title: "HERE&NOW",
    description: "Varsity Printed Pure Cotton T-shirt",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/21982472/2023/2/27/812c0298-2549-4d7e-bb1e-183c1c3b81461677475821822-HERENOW-Men-Tshirts-7701677475821300-1.jpg",
    price: "599",
    discounted_price: "239",
    category_name: "Men",
    size: "M",
    availability: true,
    delivery_time: "8",
    rating: "3.5",
  },
  {
    _id: uuid(),
    title: "KETCH",
    description: "Men Black Slim Fit Gingham Checks Checked Casual Shirt",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/16696354/2022/1/5/e3051c16-3f7f-45cf-9ae6-a8ebafd74e931641387641450KETCHMenBlackSlimFitTartanChecksCheckedCasualShirt1.jpg",
    price: "999",
    discounted_price: "399",
    category_name: "Men",
    size: "L",
    availability: false,
    delivery_time: "7",
    rating: "4.5",
  },
  {
    _id: uuid(),
    title: "HIGHLANDER",
    description: "Men White & Red Slim Fit Printed Casual Shirt",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/productimage/2021/4/8/83b64237-b332-47c6-99ef-283823a8312a1617887077149-1.jpg",
    price: "1099",
    discounted_price: "439",
    category_name: "Men",
    size: "L",
    availability: true,
    delivery_time: "2",
    rating: "2.0",
  },
  {
    _id: uuid(),
    title: "Louis Philippe",
    description: "Classic Pure Cotton Formal Shirt",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/22260118/2023/4/7/cb561ab7-7671-48f8-b824-e26da9ed2f011680844742804-Louis-Philippe-Men-Shirts-2761680844742218-1.jpg",
    price: "2299",
    discounted_price: "1379",
    category_name: "Men",
    size: "M",
    availability: true,
    delivery_time: "5",
    rating: "1.0",
  },
  {
    _id: uuid(),
    title: "Louis Philippe",
    description: "Men Grey & Blue Slim Fit Printed Pure Cotton Formal Shirt",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/18218028/2022/6/1/e2dd7c49-03a3-4f6d-bebe-68dd70eedb7b1654079499593HouseofPataudiMenPeach-ColouredEmbroideredThreadWorkRozanaKu1.jpg",
    price: "1439",
    discounted_price: "2399",
    category_name: "Men",
    size: "XL",
    availability: true,
    delivery_time: "4",
    rating: "4.7",
  },
  {
    _id: uuid(),
    title: "Vishudh",
    description: "Women Pink & White Ethnic Motifs Printed Straight Kurta",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/productimage/2021/3/9/56fab29e-26c8-4319-bdb2-dbcd5ed969f21615274238225-1.jpg",
    price: "1199",
    discounted_price: "371",
    category_name: "Women",
    size: "M",
    availability: true,
    delivery_time: "7",
    rating: "4.1",
  },
  {
    _id: uuid(),
    title: "INVICTUS",
    description:
      "Men Charcoal Grey Checked Single-Breasted Slim Fit Smart Casual Blazer",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/12816718/2021/8/17/a2fe990c-de36-4509-b71f-fa702b914b051629195532759-INVICTUS-Men-Black--Grey-Checked-Single-Breasted-Slim-Fit-Sm-1.jpg",
    price: "6499",
    discounted_price: "1999",
    category_name: "Men",
    size: "L",
    availability: true,
    delivery_time: "10",
    rating: "5.0",
  },
  {
    _id: uuid(),
    title: "Vishudh",
    description: "Women Purple & Grey Printed Kurta with Checked Palazzos",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/11862442/2020/5/18/7cef3f6b-824a-46c7-8b7d-41dec21e0bd71589798265203VishudhWomenPurple1.jpg",
    price: "4199",
    discounted_price: "545",
    category_name: "Women",
    size: "S",
    availability: true,
    delivery_time: "6",
    rating: "1.5",
  },
  {
    _id: uuid(),
    title: "KALINI",
    description: "Black & Red Floral Printed Saree",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/16423342/2021/12/9/0221662d-d402-4af7-b2b7-b25ed2113c9c1639025362323KALINIWomenBlackPrinted1.jpg",
    price: "2396",
    discounted_price: "551",
    category_name: "Women",
    size: "",
    availability: true,
    delivery_time: "3",
    rating: "3.7",
  },
  {
    _id: uuid(),
    title: "VASTRANAND",
    description:
      "Peach-Coloured & Multicoloured Kalamkari Sequinned Linen Blend Block Print Saree",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/17150536/2022/3/8/a948f638-69b9-483e-abf4-9bf256695b621646723208042-VASTRANAND-Peach-Coloured--Multicoloured-Kalamkari-Sequinned-1.jpg",
    price: "5555",
    discounted_price: "1388",
    category_name: "Women",
    size: "",
    availability: true,
    delivery_time: "6",
    rating: "4.5",
  },
  {
    _id: uuid(),
    title: "FABPIXEL",
    description:
      "Printed Semi-Stitched Lehenga & Unstitched Blouse With Dupatta",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/22030152/2023/2/17/54ca6bbe-dbf0-4675-bcf8-52edead5f2081676655906575BlueGeorgetteStripedFlaredLehengaCholiwithDupatta1.jpg",
    price: "2399",
    discounted_price: "1999",
    category_name: "Women",
    size: "M",
    availability: true,
    delivery_time: "8",
    rating: "4.5",
  },
  {
    _id: uuid(),
    title: "SHEETAL Associates",
    description: "Purple Dress",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19062894/2022/7/12/64b4678f-adc0-48d9-81cc-3c67ec3556f91657572750226Dresses1.jpg",
    price: "1999",
    discounted_price: "519",
    category_name: "Women",
    size: "XL",
    availability: true,
    delivery_time: "8",
    rating: "2.5",
  },
  {
    _id: uuid(),
    title: "Aarika",
    description: "Women Off White Embroidered Crop Open Front Jacket",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/18156068/2022/5/26/9da21940-b2d8-4b67-9ab3-afb2580e24551653564778579-Aarika-Women-Off-White-Embroidered-Crop-Open-Front-Jacket-44-1.jpg",
    price: "1999",
    discounted_price: "799",
    category_name: "Women",
    size: "L",
    availability: true,
    delivery_time: "3",
    rating: "4.5",
  },
  {
    _id: uuid(),
    title: "HELLCAT",
    description: "Boys Pack Of 5 Typography Printed Bio Finish T-shirt",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/17137550/2022/2/11/b124b0f4-830d-44ed-a669-e8585d66cf4f1644579708683HellcatBoysRoundNeckBlendedCottonTshirt-ComboPackof51.jpg",
    price: "4999",
    discounted_price: "699",
    category_name: "Kid",
    size: "S",
    availability: true,
    delivery_time: "5",
    rating: "4.3",
  },
  {
    _id: uuid(),
    title: "H&M",
    description: "Boys White Pure Cotton Slim Fit T-shirt",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19283072/2022/7/28/f1c134f7-4f4b-42ad-8d49-f03042ed8bf21659002013493CottonT-shirt1.jpg",
    price: "499",
    discounted_price: "399",
    category_name: "Kid",
    size: "S",
    availability: true,
    delivery_time: "5",
    rating: "4.1",
  },
  {
    _id: uuid(),
    title: "H&M",
    description: "Boys 5-pack Cotton T-shirts",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/16929800/2022/1/25/c9670d8c-fc30-4182-a59a-b5789b9899e116431006892315-packcottonT-shirts1.jpg",
    price: "5999",
    discounted_price: "1999",
    category_name: "Kid",
    size: "S",
    availability: true,
    delivery_time: "5",
    rating: "4.8",
  },
  {
    _id: uuid(),
    title: "WROGN YOUTH",
    description:
      "Boys Off White Printed Polo Collar Pure Cotton Slim Fit T-shirt",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19193024/2022/11/4/180af3fd-7085-4cfb-a7b5-c3592a0401b91667574867543WROGNYOUTHBoysOffWhitePrintedPoloCollarPureCottonSlimFitT-sh1.jpg",
    price: "1599",
    discounted_price: "639",
    category_name: "Kid",
    size: "S",
    availability: true,
    delivery_time: "5",
    rating: "4.2",
  },
  {
    _id: uuid(),
    title: "Marks & Spencer",
    description: "Boys Blue High-Rise Jeans",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19820144/2022/9/8/2e67dd5e-5d1f-43f0-9036-369f09c9b55c1662616297829MarksSpencerBoysBlueHigh-RiseJeans1.jpg",
    price: "1499",
    discounted_price: "899",
    category_name: "Kid",
    size: "S",
    availability: true,
    delivery_time: "5",
    rating: "2.5",
  },
  {
    _id: uuid(),
    title: "WROGN YOUTH",
    description: "Boys Blue Skinny Fit Light Fade Stretchable Jeans",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19192966/2022/8/16/68c99584-c159-4199-b733-74a1e82cf0861660652693952-WROGN-YOUTH-Boys-Blue-Skinny-Fit-Light-Fade-Stretchable-Jean-11.jpg",
    price: "2799",
    discounted_price: "1119",
    category_name: "Kid",
    size: "S",
    availability: true,
    delivery_time: "5",
    rating: "1.5",
  },
  {
    _id: uuid(),
    title: "HIGHLANDER",
    description: "Men Olive Green Solid Slim Fit Casual Shirt",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19771884/2022/10/28/d62de621-d236-4a68-88f9-5b899d7369651666942676149-HIGHLANDER-Men-Olive-Green-Solid-Slim-Fit-Casual-Shirt-96516-1.jpg",
    price: "1999",
    discounted_price: "439",
    category_name: "Men",
    size: "M",
    availability: true,
    delivery_time: "5",
    rating: "4.5",
  },
];
